// this accepts 0.0 and 0.00 but wont accept 0 or 0.
export const Percentage1or2DecimalsRegex = /^([1-9][0-9]{0,2}|([0]|[1-9][0-9]{0,2})[.]{1}[0-9]{1}|([0]|[1-9][0-9]{0,2})[.]{1}[0-9]{2})$/;
//# sourceMappingURL=regex.js.map